import React from 'react';

import { TaskApi } from '../../../../../../../../api';
import ModalBoxes from '../../../../../../../../common/feedback/ModalBoxes/ModalBoxes';
import NotificationManager from '../../../../../../../../common/notifications/NotificationManager';
import {
  TASK_ATTACHMENT_REMOVE_FAILED,
  TASK_ATTACHMENT_REMOVED
} from '../../../../../../../../constants/notificationMessages';

import AddTaskAttachmentModal from './AddTaskAttachmentModal';
import { FileViewer, TaskAttachment, TaskModalBoxes } from './taskAttachmentTypes';

const TaskModalBoxesTyped = ModalBoxes as TaskModalBoxes;

type UseTaskDetailsAttachmentsActionsParams = {
  taskId?: string;
  ssuId?: string;
  onAttachmentSaved?: () => void | Promise<void>;
  fileViewer: FileViewer;
};

type UseTaskDetailsAttachmentsActionsResult = {
  openAddAttachmentModal: () => void;
  openAttachmentPreview: (attachment: TaskAttachment) => void;
  confirmRemoveAttachment: (attachment: TaskAttachment) => void;
};

export default function useTaskDetailsAttachmentsActions({
  taskId,
  ssuId,
  onAttachmentSaved,
  fileViewer
}: UseTaskDetailsAttachmentsActionsParams): UseTaskDetailsAttachmentsActionsResult {
  function openAddAttachmentModal() {
    if (!taskId || !ssuId) return;
    TaskModalBoxesTyped.open({
      component: <AddTaskAttachmentModal taskId={taskId} ssuId={ssuId} onAttachmentSaved={onAttachmentSaved} />
    });
  }

  function openAttachmentPreview(attachment: TaskAttachment) {
    if (!taskId || !ssuId || !attachment.fileId || !fileViewer?.openFileByPromise) return;
    fileViewer.openFileByPromise(TaskApi.previewAttachment(taskId, ssuId, attachment.fileId));
  }

  function confirmRemoveAttachment(attachment: TaskAttachment) {
    if (!taskId || !ssuId || !attachment.fileId) return;

    TaskModalBoxesTyped.confirm({
      content: `Are you sure you want to remove ${attachment.fileName}?`,
      confirmButton: 'Remove',
      cancelButton: 'Cancel'
    })
      .then(async () => {
        try {
          await TaskApi.removeAttachment(taskId, ssuId, attachment.fileId);
          onAttachmentSaved?.();
          NotificationManager.success(TASK_ATTACHMENT_REMOVED);
        } catch {
          NotificationManager.error(TASK_ATTACHMENT_REMOVE_FAILED);
        }
      })
      .catch(() => {});
  }

  return {
    openAddAttachmentModal,
    openAttachmentPreview,
    confirmRemoveAttachment
  };
}
